<template>
    <div>
        <Table :columns="Fixedcolumndata" size="small" stripe :data="tableData" :row-class-name="rowClassName"></Table>
        <div class="paging_style">
            <Page size="small"  :total="total" :page-size="query.pageSize" show-total show-elevator :current="query.pageNumber" @on-change="changePage"></Page>
        </div>
    </div>
</template>

<script>
import { getProductDetailPageByOrder } from '@/api/order/productdetail'
import { formatOrderSaleType } from '@/utils/tagStatus'
import { toMoney } from '@/utils/wnumb_own'

export default {
  props: {
    orderId: {
      type: [Number, String],
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    customskuId: {
      type: Number
    }
  },
  data () {
    return {
      tableData: [],
      Fixedcolumndata: [ // 显示地铁灯箱或者路面媒体
        {
          title: '资源编号',
          key: 'resourceCode'
        },
        { title: '资源等级', key: 'stationLevelName', width: 90 },
        {
          renderHeader: (h, params) => {
            if (this.product.productType === 5) {
              return h('span', '站点编号')
            } else {
              return h('span', '所属楼层')
            }
          },
          width: 90,
          render: (h, params) => {
            if (this.product.productType === 5) {
              return h('span', params.row.stationCode)
            } else {
              return h('span', params.row.floor)
            }
          }
        },
        { title: '位置', key: 'positionName', width: 90 },
        {
          renderHeader: (h, params) => {
            if (this.product.productType === 5) {
              return h('span', '所属站点/站点类型')
            } else {
              return h('span', '所属站点')
            }
          },
          render: (h, params) => {
            if (this.product.productType === 5) {
              return h('span', params.row.stationName + '[' + params.row.stationTypeName + ']')
            } else {
              return h('span', params.row.stationName)
            }
          }
        },
        { title: '所属资产', key: 'assetName' },
        {
          title: '采购类型',
          align: 'center',
          render: (h, data) => {
            if (this.query.priceType === 0) {
              return formatOrderSaleType(h, this.query.priceType)
            } else {
              return formatOrderSaleType(h, data.row.type)
            }
          }
        }
      ],
      query: {
        orderId: this.orderId,
        productId: this.product.productId,
        subitemproductId: this.product.subitemproductId,
        pageNumber: 1,
        pageSize: 10,
        keyword: '',
        startDate: this.product.startDate,
        endDate: this.product.endDate,
        priceType: this.product.priceType
      },
      total: 0,
      currentProduct: {}
    }
  },
  created () {
    this.initColumn()
    this.initPurchaseList()
  },
  methods: {
    initColumn () {
      if (!this.customskuId) {
        this.Fixedcolumndata.push(
          {
            title: '价格',
            render: (h, data) => {
              const showSpan = []
              if (this.query.priceType === 0) {
                showSpan.push(h('span', toMoney(data.row.settlementPrice)))
                showSpan.push(h('span', { style: { color: '#ed4014' } }, '（' + (data.row.discount * 10).toFixed(2) + '折）'))
              } else {
                showSpan.push(h('span', toMoney(data.row.useprice)))
              }

              if (data.row.duration > 1) {
                showSpan.push(h('span', '( ' + data.row.duration + '秒)'))
              }

              return h('div', showSpan)
            }
          }
        )
      }
    },
    rowClassName (row, index) {
      return row.conflict ? 'table-conflict-row' : ''
    },
    initPurchaseList () {
      if (this.hiddenOrderPoint) { return }

      this.query.productId = this.customskuId ? this.product.curProductId : this.product.productId
      this.query.orderId = this.orderId
      this.query.customskuId = this.customskuId || undefined
      getProductDetailPageByOrder(this.query).then(res => {
        this.tableData = res.list
        this.total = res.totalRow
        this.query.pageNumber = res.pageNumber
      })
    },
    changePage (currentPage) {
      this.query.pageNumber = currentPage
      this.initPurchaseList()
    },
    ReLoadData (allowAssetIds) {
      this.query.pageNumber = 1

      this.query.assetIds = JSON.stringify(allowAssetIds)
      this.initPurchaseList()
    }
  }
}
</script>
